import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  isAPILoading: false,
  addNewsLetterStatus: '',
  addRecruitStatus: '',
  addProjectStatus: '',
  addPdsStatus: ''
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
